import { useState } from 'react';

export function useCancelPreScrollAnimation() {
    const [animationCancelled, setAnimationCancelled] = useState(false);
    const [canCancelAnimation, setCanCancelAnimation] = useState(true);
    const onAnimationStart = () => {
        setCanCancelAnimation(false);
    };
    const cancelAnimation = () => {
        if (canCancelAnimation) {
            setAnimationCancelled(true);
        }
    };
    return { onAnimationStart, cancelAnimation, animationCancelled };
}
